import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-loader-spinner',
  standalone: true,
  imports: [ProgressSpinnerModule, CommonModule],
  templateUrl: './loader-spinner.component.html',
  styles: `
    :host {
      display: block;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderSpinnerComponent {
    @Input() isLoading: boolean = false;
}
